import React from 'react';
import Image from 'next/image';

const Amex = () => (
  <Image src="/images/amex.png" alt="Accepts American Express" height={20} width={20} />
);

export default Amex;
